var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ChevronUpDownIcon, ArrowUpIcon, ArrowDownIcon, } from '@heroicons/react/20/solid';
import { cn } from 'utils/ui/classes';
import { ORDER, SortProvider, useSort } from './table/TableSorting';
export function Table(_a) {
    var { children, className, dataTestId } = _a, props = __rest(_a, ["children", "className", "dataTestId"]);
    return ((React.createElement("table", Object.assign({ "data-testid": dataTestId, className: cn('min-w-full divide-y divide-gray-300', className) }, props), children)));
}
export function TableRow(_a) {
    var { children, className, dataTestId } = _a, props = __rest(_a, ["children", "className", "dataTestId"]);
    return ((React.createElement("tr", Object.assign({ "data-testid": dataTestId, className: cn('border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted', className) }, props), children)));
}
export function TableHead(_a) {
    var { children, className, dataTestId } = _a, props = __rest(_a, ["children", "className", "dataTestId"]);
    return ((React.createElement("th", Object.assign({ "data-testid": dataTestId, className: cn('px-3 py-3.5 text-left text-sm font-semibold text-gray-900', className) }, props), children)));
}
export function TableCell(_a) {
    var { children, className, dataTestId } = _a, props = __rest(_a, ["children", "className", "dataTestId"]);
    return ((React.createElement("td", Object.assign({ "data-testid": dataTestId, className: cn('whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate', className) }, props), children)));
}
export function TableHeader(_a) {
    var { children, className, onSortChange, dataTestId } = _a, props = __rest(_a, ["children", "className", "onSortChange", "dataTestId"]);
    return ((React.createElement(SortProvider, { dataTestId: "SortProvider-bdb9b0bb", onSortChange: onSortChange },
        React.createElement("thead", Object.assign({ "data-testid": dataTestId, className: cn('bg-gray-50', className) }, props), children))));
}
export function TableBody(_a) {
    var { children, className, dataTestId } = _a, props = __rest(_a, ["children", "className", "dataTestId"]);
    return ((React.createElement("tbody", Object.assign({ "data-testid": dataTestId, className: cn('bg-white', className) }, props), children)));
}
export function TableFooter(_a) {
    var { children, className, dataTestId } = _a, props = __rest(_a, ["children", "className", "dataTestId"]);
    return ((React.createElement("tfoot", Object.assign({ "data-testid": dataTestId, className: cn(className) }, props), children)));
}
export function SortableColumnHeader(_a) {
    var { children, className, alignment, sortKey, dataTestId } = _a, props = __rest(_a, ["children", "className", "alignment", "sortKey", "dataTestId"]);
    const { sortKey: currentSortKey, sortOrder: currentSortOrder, onSortChange, } = useSort();
    const isActiveSorting = currentSortKey === sortKey;
    return ((React.createElement(TableHead, Object.assign({ dataTestId: dataTestId, className: className }, props),
        React.createElement("button", { "data-testid": "button-74fd9e35", className: cn('flex items-center gap-1 w-full', {
                'justify-start': alignment === 'left',
                'justify-end': alignment === 'right',
                'justfy-center': alignment === 'center',
                'cursor-pointer': sortKey,
            }), disabled: !sortKey, onClick: () => sortKey && onSortChange(sortKey) },
            React.createElement("div", { "data-testid": "div-fd418439" }, children),
            isActiveSorting &&
                (currentSortOrder === ORDER.ASC ? (React.createElement(ArrowDownIcon, { className: "flex-none h-4" })) : (React.createElement(ArrowUpIcon, { className: "flex-none h-4" }))),
            !isActiveSorting && sortKey && (React.createElement(ChevronUpDownIcon, { className: "flex-none h-4 text-gray-400" }))))));
}
